{
  "请输入有效的 UUID v7": "Enter a valid UUID v7",
  "供需宣传图": "Opportunity image",
  "供需宣传图 #{{id}}": "Opportunity image #{{id}}",
  "API 常驻内存（RSS）": "API resident memory (RSS)",
  "API 运行时间": "API uptime",
  "CPU 型号": "CPU model",
  "Excel 工作簿": "Excel workbook",
  "Excel 解析失败，文件可能损坏或已加密，请下载查看": "Unable to parse Excel. The file may be damaged or encrypted. Download it to view.",
  "Excel 解析超时，请下载查看": "Excel parsing timed out. Download the file to view.",
  "Excel 超过 20 MiB，请下载查看": "Excel file exceeds 20 MiB. Download it to view.",
  "Excel 预览加载失败": "Unable to load the Excel preview",
  "GIF 图片": "GIF image",
  "JPEG 图片": "JPEG image",
  "MP3 音频": "MP3 audio",
  "MP4 视频": "MP4 video",
  "PDF 文档": "PDF document",
  "PDF 预览": "PDF preview",
  "PNG 图片": "PNG image",
  "Path-style 请求": "Path-style requests",
  "Redis 不可用": "Redis unavailable",
  "Redis 关键指标": "Redis key metrics",
  "Redis 启动以来的查询命中比例": "Cache hit ratio since Redis started",
  "Redis 版本": "Redis version",
  "Session Token 需与完整访问凭据一起更新": "Update the session token together with the complete access credentials",
  "Session Token（可选）": "Session token (optional)",
  "WebM 视频": "WebM video",
  "WebP 图片": "WebP image",
  "Webhook 同时发送。": "Also delivered by webhook.",
  "Webhook 已配置，待发送 {{pending}}；最近投递：{{outcome}}": "Webhook configured. Pending: {{pending}}; latest delivery: {{outcome}}",
  "Worker：{{value}}": "Workers: {{value}}",
  "{{label}}：{{value}}": "{{label}}: {{value}}",
  "{{name}} 存储": "Storage: {{name}}",
  "{{name}} 已上传": "{{name}} uploaded",
  "{{name}} 的更多操作": "More actions for {{name}}",
  "{{name}}{{default}} · {{visibility}}": "{{name}}{{default}} · {{visibility}}",
  "{{name}}：{{error}}": "{{name}}: {{error}}",
  "{{name}}：文件不能超过 {{size}}": "{{name}}: file must not exceed {{size}}",
  "{{name}}：该文件类型不支持上传": "{{name}}: this file type cannot be uploaded",
  "{{value}} 位用户未全部发送成功": "Recipients with incomplete delivery: {{value}}",
  "{{value}} 处引用": "References: {{value}}",
  "一次最多删除 50 个文件": "Delete up to 50 files at a time",
  "上一页": "Previous",
  "上传 {{value}} 个文件": "Upload files ({{value}})",
  "上传文件": "Upload files",
  "上传时间": "Upload time",
  "上传者": "Uploaded by",
  "上传者 ID": "Uploader ID",
  "上次采集": "Previous collection",
  "下一页": "Next",
  "下载": "Download",
  "不再生成新的周期任务，不取消正在执行的任务。": "Stops creating recurring jobs. Running jobs will continue.",
  "业务变更": "Business changes",
  "业务变更历史": "Business change history",
  "业务引用（{{value}}）": "Business references ({{value}})",
  "业务用户 #{{id}}": "Business user #{{id}}",
  "业务用户 ID": "Business user ID",
  "个人头像": "Profile picture",
  "临时内存盘读写测试通过，不代表持久存储": "Temporary memory storage read/write test passed. This is not persistent storage.",
  "主机与运行环境": "Host and runtime",
  "主机名称": "Hostname",
  "仅删除配置，不扫描或删除存储中的其他文件。": "Only deletes the configuration. Other stored files will not be scanned or deleted.",
  "仅加载所选用户的有效会话": "Only active sessions for the selected user are loaded",
  "仅展示当前 API 实例。系统内存不代表容器配额，系统负载不是 CPU 使用率。": "Shows only the current API instance. System memory is not the container quota; system load is not CPU utilization.",
  "仅显示 7 天前且无引用的文件。删除前仍需确认，不会自动清理。": "Only unreferenced files older than 7 days are shown. Deletion requires confirmation; files are not cleaned up automatically.",
  "仅能删除空文件夹。": "Only empty folders can be deleted.",
  "仍有文件记录，不能删除": "Cannot delete storage with file records",
  "任务中心": "Tasks",
  "任务中心未启用（TASKS_MODE=off）": "Task center is disabled (TASKS_MODE=off)",
  "任务将重新入队，由 Worker 执行。": "The task will be queued again for a worker to execute.",
  "任务已入队": "Task queued",
  "任务已重新入队": "Task requeued",
  "任务状态": "Task status",
  "任务编号": "Task ID",
  "依赖就绪：{{ready}} · 检查时间：{{time}}": "Dependencies ready: {{ready}} · Checked at: {{time}}",
  "保存": "Save",
  "保存调度": "Save schedule",
  "修改": "Change",
  "全部": "All",
  "全部存储": "All storage",
  "全部已读": "Mark all as read",
  "全部文件": "All files",
  "全部类型": "All types",
  "全部驱动": "All drivers",
  "公开": "Public",
  "公开存储": "Public storage",
  "公开存储，请勿上传敏感资料。": "Public storage. Do not upload sensitive information.",
  "公开访问地址": "Public URL",
  "关键词": "Keyword",
  "关闭": "Close",
  "内存上限": "Memory limit",
  "内存使用": "Memory usage",
  "内存峰值": "Peak memory",
  "内存文件在重启后全部丢失，仅用于测试，不适合正式附件存储。": "All in-memory files are lost on restart. Use only for testing, not production attachments.",
  "凭据：{{status}}": "Credentials: {{status}}",
  "分配堆内存": "Allocated heap memory",
  "切换驱动会清除旧凭据": "Changing the driver clears existing credentials",
  "列表视图": "List view",
  "创建时间": "Created at",
  "删除": "Delete",
  "删除失败": "Deletion failed",
  "删除存储“{{name}}”？": "Delete storage “{{name}}”?",
  "删除文件夹「{{name}}」？": "Delete folder “{{name}}”?",
  "刷新": "Refresh",
  "刷新告警": "Refresh alerts",
  "刷新存储": "Refresh storage",
  "刷新文件": "Refresh files",
  "刷新消息": "Refresh messages",
  "加载中": "Loading",
  "加载文件中": "Loading files",
  "动作": "Action",
  "包含受保护文件或正在加载": "Contains protected files or is still loading",
  "即时发送": "Send immediately",
  "历史待核实": "Historical record awaiting verification",
  "历史记录的文件名、大小或上传者可能缺失；核实前禁止删除。": "Historical records may lack a filename, size, or uploader. Verify them before deletion.",
  "原始文件名未知": "Original filename unknown",
  "发生时间": "Occurred at",
  "发送": "Send",
  "发送渠道": "Delivery channels",
  "发送结果": "Delivery results",
  "发送通知": "Send notification",
  "取消": "Cancel",
  "取消选择": "Clear selection",
  "受控作业": "Managed jobs",
  "变更前": "Before",
  "变更后": "After",
  "只读": "Read-only",
  "只读预览 · 最多 50 张工作表，每表前 500 行、50 列；不执行公式。": "Read-only preview · Up to 50 sheets, showing the first 500 rows and 50 columns of each. Formulas are not executed.",
  "可留空使用部署环境凭据": "Leave blank to use deployment environment credentials",
  "可选，例如 /profile": "Optional, e.g. /profile",
  "同时删除存储中的文件和台账记录，无法恢复。服务端会重新检查业务引用。": "Permanently deletes both stored files and their records. The server will recheck business references.",
  "名称": "Name",
  "名称不能包含路径分隔符或控制字符": "Names cannot contain path separators or control characters",
  "后台发送通知": "Queue notification",
  "后台投递记录": "Background delivery records",
  "后台投递记录（最近 100 条）": "Background delivery records (latest 100)",
  "否": "No",
  "启用": "Enable",
  "告警": "Alert",
  "告警写入数据库，重启后继续投递，并邮件通知平台管理员。{{webhook}}待发送 {{pending}}；最近投递：{{outcome}}": "Alerts are stored in the database, delivery resumes after restart, and platform administrators are notified by email. {{webhook}} Pending: {{pending}}; latest delivery: {{outcome}}",
  "告警同步写入运行日志，尚未接通外部通知渠道。": "Alerts are written to application logs. No external notification channel is connected.",
  "回收站": "Trash",
  "图片": "Image",
  "地域": "Region",
  "堆内存使用率": "Heap memory utilization",
  "复制位置": "Copy location",
  "大小": "Size",
  "失败": "Failed",
  "失败提示": "Failure details",
  "如 200": "e.g. 200",
  "姓名、账号、手机号、邮箱或 ID": "Name, account, phone, email, or ID",
  "存储": "Storage",
  "存储位置": "Storage location",
  "存储名称": "Storage name",
  "存储名称不可修改；凭据不回显，留空保留已有值。位置变更可能导致历史文件失联，请优先新增存储。": "Storage names cannot be changed. Credentials are hidden; leave blank to keep existing values. Changing the location may make existing files inaccessible. Add new storage instead when possible.",
  "存储读写测试通过，测试文件已清理": "Storage read/write test passed. Test files have been removed.",
  "存储配置": "Storage configuration",
  "存储配置加载失败，请刷新重试": "Unable to load storage configuration. Refresh to retry.",
  "存储配置已保存，需重启服务后生效": "Storage configuration saved. Restart the service to apply it.",
  "存储配置已删除": "Storage configuration deleted",
  "存储键": "Storage key",
  "存储驱动": "Storage driver",
  "存在失败通知": "Failed notifications exist",
  "存在待核实邮件": "Email delivery needs verification",
  "完成": "Done",
  "完整请求 ID": "Full request ID",
  "实例信息": "Instance information",
  "对象": "Target",
  "将 {{value}} 个文件移入回收站？": "Move files to trash ({{value}})?",
  "将删除所有成功和失败的执行记录，删除后无法恢复或重试。等待、执行中和延迟任务不受影响。": "Deletes all successful and failed execution records. They cannot be recovered or retried. Waiting, active, and delayed tasks are unaffected.",
  "小写字母开头，最多 64 位字母、数字、下划线或短横线": "Start with a lowercase letter; up to 64 lowercase letters, digits, underscores, or hyphens",
  "尚未发送": "Not sent yet",
  "尝试次数": "Attempts",
  "工作簿为空": "Workbook is empty",
  "已保存": "Saved",
  "已停用": "Disabled",
  "已关闭": "Disabled",
  "已全部标为已读": "All messages marked as read",
  "已删除 {{deleted}} 个文件，{{failed}} 个删除失败，请重试": "Files deleted: {{deleted}}. Failed: {{failed}}. Please retry.",
  "已删除 {{value}} 个文件": "Files deleted: {{value}}",
  "已加入投递队列，可在投递记录中查看": "Queued for delivery. Check delivery records for progress.",
  "已加密设置": "Encrypted credentials saved",
  "已启用": "Enabled",
  "已复制": "Copied",
  "已恢复": "Restored",
  "已接受": "Accepted",
  "已提交": "Submitted",
  "已提交表示渠道已接收。状态待核实的邮件请先核对服务商记录：确认已送达不会重发，确认未送达后才能重试。超过 30 天的已完成记录会由任务中心清理。": "Submitted means the channel accepted the message. For unverified email, check the provider's records: confirming delivery will not resend it; confirm non-delivery before retrying. Completed records older than 30 days are removed by the task center.",
  "已断连": "Disconnected",
  "已用内存": "Used memory",
  "已用堆内存": "Used heap memory",
  "已移入回收站": "Moved to trash",
  "已记录核实结果": "Verification result saved",
  "已设置，留空保留": "Configured; leave blank to keep",
  "已跳过 {{value}} 条未完成或无法解析的记录": "Incomplete or unparseable records skipped: {{value}}",
  "已选 {{value}} 项": "Selected: {{value}}",
  "已重新排队": "Requeued",
  "延迟": "Delayed",
  "引用中及历史待核实文件不可删除。": "Referenced files and unverified historical files cannot be deleted.",
  "当前实例最近 50 次状态变化。": "Latest 50 state changes for this instance.",
  "当前平台不支持": "Not supported on this platform",
  "当前数据库": "Current database",
  "当前数据库键数": "Keys in current database",
  "当前未发现告警": "No active alerts",
  "当前用户": "Current user",
  "当前结果已截断": "Results have been truncated",
  "待处理 {{pending}} · 超时等待 {{overdue}} · 失败 {{failed}} · 待核实 {{uncertain}}": "Pending {{pending}} · Overdue {{overdue}} · Failed {{failed}} · Unverified {{uncertain}}",
  "待投递通知的任务中心未启用": "Task center is disabled while notifications await delivery",
  "待重启": "Restart required",
  "待重试删除": "Deletion retry pending",
  "总数仅代表本次扫描范围内的匹配记录，并非该日完整日志；完整记录请使用服务器日志文件。": "The total counts matching records within this scan, not all logs for the day. Use server log files for complete records.",
  "恢复所选": "Restore selected",
  "恢复队列": "Resume queue",
  "恢复队列？": "Resume queue?",
  "成功": "Success",
  "所在文件夹": "Parent folder",
  "打开": "Open",
  "打开文件夹 {{name}}": "Open folder {{name}}",
  "执行中": "Running",
  "执行记录": "Execution records",
  "投递中": "Delivering",
  "投递统计不可用": "Delivery statistics unavailable",
  "投递记录": "Delivery records",
  "投递运行告警": "Deliver operational alerts",
  "按 UTC 日期查询，时间列按浏览器本地时区显示。新记录通常在 250ms 后入库。": "Query by UTC date. Times use the browser's local time zone. New records are usually stored after 250 ms.",
  "按 UTC 日期读取最近 8 MiB / 5000 条记录；大流量时结果可能截断。历史文件按保留策略清理。": "Reads the latest 8 MiB / 5,000 records by UTC date. High traffic may truncate results. Historical files are removed according to the retention policy.",
  "按姓名或邮箱搜索登录账号": "Search login accounts by name or email",
  "按姓名或邮箱选择用户": "Select a user by name or email",
  "搜索姓名或邮箱，最多 50 人": "Search by name or email, up to 50 recipients",
  "搜索存储": "Search storage",
  "搜索文件": "Search files",
  "搜索文件名": "Search filenames",
  "撤销会话会立即使对应设备退出登录，需要重新登录。": "Revoking a session immediately signs out that device. The user must sign in again.",
  "操作": "Actions",
  "操作审计": "Audit log",
  "操作系统 / 架构": "Operating system / architecture",
  "操作者": "Actor",
  "支持图片、PDF、视频、音频和 XLSX，每个文件最大 {{size}}": "Supports images, PDF, video, audio, and XLSX. Maximum {{size}} per file.",
  "收件人": "Recipients",
  "收件人不可用": "Recipient unavailable",
  "数据库不可用": "Database unavailable",
  "数据库审计 · 包含查询、下载、变更和认证操作": "Database audit · Includes queries, downloads, changes, and authentication",
  "整理文件": "Organize file",
  "整理文件夹": "Organize folder",
  "文件": "File",
  "文件 #{{id}}": "File #{{id}}",
  "文件上传": "Upload files",
  "文件会从列表消失，30 天内可以在回收站恢复。引用中的文件不能移入。": "Files are removed from the list and can be restored from trash within 30 days. Referenced files cannot be moved to trash.",
  "文件内容": "File contents",
  "文件分类": "File categories",
  "文件列表": "Files",
  "文件前缀": "File prefix",
  "文件加载失败": "Unable to load files",
  "文件名": "Filename",
  "文件夹": "Folder",
  "文件夹已删除": "Folder deleted",
  "文件当前不可预览": "This file cannot currently be previewed",
  "文件浏览器": "File browser",
  "文件空间": "File space",
  "文件类型": "File type",
  "文件记录": "File records",
  "文件详情": "File details",
  "文件详情加载失败": "Unable to load file details",
  "文件预览": "File preview",
  "新增": "Add",
  "新增存储": "Add storage",
  "新建文件夹": "New folder",
  "方法": "Method",
  "无引用": "No references",
  "无法打开关联页面": "Unable to open the linked page",
  "无法读取文件内容": "Unable to read file contents",
  "无法读取文件（HTTP {{status}}）": "Unable to read file (HTTP {{status}})",
  "无法预览 Excel": "Unable to preview Excel",
  "无请求上下文": "No request context",
  "日志已清空": "Logs cleared",
  "日志详情": "Log details",
  "日期（UTC）": "Date (UTC)",
  "时间": "Time",
  "明确清除已保存的全部凭据": "Clear all saved credentials",
  "是": "Yes",
  "暂停后不领取新任务，正在执行的任务继续完成。": "Pausing stops new tasks from being picked up. Running tasks will finish.",
  "暂停队列": "Pause queue",
  "暂停队列？": "Pause queue?",
  "暂无匹配日志，请调整日期或筛选条件": "No matching logs. Adjust the date or filters.",
  "暂无在线 Worker，已入队任务将等待消费。": "No workers are online. Queued tasks will wait for a worker.",
  "暂无存储配置": "No storage configured",
  "暂无拥有登录账号的用户": "No users with login accounts",
  "暂无未读消息": "No unread messages",
  "暂无消息": "No messages",
  "更早记录": "Older records",
  "最新记录": "Latest records",
  "最近采集": "Latest collection",
  "服务关键指标": "Service key metrics",
  "服务端点": "Endpoint",
  "未关联业务用户": "No linked business user",
  "未知": "Unknown",
  "未记录认证身份": "No authentication identity recorded",
  "未设置 / 使用环境凭据": "Not set / using environment credentials",
  "未识别身份": "Unidentified actor",
  "未读": "Unread",
  "未选择": "Not selected",
  "未配置 Webhook。": "Webhook not configured.",
  "未限制": "Unlimited",
  "本地目录": "Local directory",
  "本地签名通道仅服务运行中的默认磁盘；文件管理下载接口不依赖此配置。": "The local signed route serves only the active default disk. File-management downloads do not depend on this setting.",
  "本机文件日志 · 仅显示当前部署实例日志目录中的记录": "Local file logs · Shows only records in this deployment instance's log directory",
  "权限已失效": "Authorization expired",
  "来源": "Source",
  "松开文件，准备上传": "Drop files to prepare upload",
  "查看全部": "View all",
  "查看登录时间、设备和 IP，并按需撤销会话": "View sign-in times, devices, and IP addresses, and revoke sessions as needed",
  "标记已读 {{title}}": "Mark {{title}} as read",
  "标题": "Title",
  "标题不能包含换行": "Title cannot contain line breaks",
  "标题最多 120 字": "Title must be at most 120 characters",
  "模块": "Module",
  "正在加载消息": "Loading messages",
  "正在采集": "Collecting",
  "正文": "Body",
  "正文最多 5000 字": "Body must be at most 5,000 characters",
  "每 30 秒自动刷新": "Refreshes automatically every 30 seconds",
  "每 {{seconds}} 秒；下次 {{time}}": "Every {{seconds}} seconds; next run {{time}}",
  "每个签名密钥至少 32 位，多密钥用逗号分隔": "Each signing key must contain at least 32 characters. Separate multiple keys with commas.",
  "每秒命令数": "Commands per second",
  "永久删除": "Delete permanently",
  "永久删除 {{value}} 个文件？": "Permanently delete files ({{value}})?",
  "永久删除（{{value}}）": "Delete permanently ({{value}})",
  "没有匹配的存储": "No matching storage",
  "没有匹配的登录账号": "No matching login accounts",
  "没有在线 Worker": "No workers online",
  "没有符合条件的文件，试试调整筛选": "No matching files. Try adjusting the filters.",
  "消息": "Message",
  "消息中心": "Message center",
  "消息关联页面不可用": "The linked page is unavailable",
  "消息列表": "Message list",
  "消息或模块": "Message or module",
  "清理变更历史": "Clean up change history",
  "清理回收站": "Empty expired trash",
  "清理过期投递": "Clean up expired deliveries",
  "清理预览": "Cleanup preview",
  "清空": "Clear",
  "清空日志": "Clear logs",
  "清空日志？": "Clear logs?",
  "清除可能使存储不可用，请确认已有替代凭据。": "Clearing credentials may make storage unavailable. Ensure replacement credentials are available.",
  "渠道": "Channel",
  "点击或拖拽文件到这里": "Click or drag files here",
  "照片存储不能删除": "Photo storage cannot be deleted",
  "照片记录 #{{id}}": "Photo record #{{id}}",
  "认证材料 #{{id}}": "Verification document #{{id}}",
  "状态": "Status",
  "状态待核实": "Needs verification",
  "状态码": "Status code",
  "用户 #{{id}}": "User #{{id}}",
  "用户照片": "User photos",
  "用户编号": "User ID",
  "用户选择面板": "User selection panel",
  "留空保留已有密钥": "Leave blank to keep existing keys",
  "留空按地域生成；填写服务端点，不含桶名": "Leave blank to generate from the region. Enter the service endpoint without the bucket name.",
  "留空表示不提供公开链接；填写地址本身不会修改桶的访问策略。": "Leave blank to disable public links. Setting a URL does not change the bucket's access policy.",
  "登录会话": "Sign-in sessions",
  "登录会话面板": "Login sessions panel",
  "目标存储": "Destination storage",
  "相对目录以 API 工作目录为基准。仅可信运维可配置本地路径。": "Relative paths are based on the API working directory. Only trusted operators should configure local paths.",
  "确认": "Confirm",
  "确认已送达": "Confirm delivered",
  "确认未送达": "Confirm not delivered",
  "私有": "Private",
  "私有存储": "Private storage",
  "移入回收站": "Move to trash",
  "移入回收站（{{value}}）": "Move to trash ({{value}})",
  "移除调度": "Remove schedule",
  "移除调度？": "Remove schedule?",
  "立即执行": "Run now",
  "站内信": "Inbox",
  "第 {{page}} 页": "Page {{page}}",
  "等待": "Waiting",
  "等待投递": "Pending delivery",
  "筛选": "Filter",
  "筛选存储驱动": "Filter storage drivers",
  "筛选（{{value}}）": "Filter ({{value}})",
  "签名密钥（可选）": "Signing keys (optional)",
  "签名路由地址（可选）": "Signed route URL (optional)",
  "类型": "Type",
  "系统内存使用率": "System memory utilization",
  "系统已用内存": "Used system memory",
  "系统总内存": "Total system memory",
  "系统或未知来源": "System or unknown source",
  "系统空闲内存": "Free system memory",
  "系统负载（1 / 5 / 15 分钟）": "System load (1 / 5 / 15 minutes)",
  "系统连通性检查": "System connectivity check",
  "级别": "Level",
  "结束时间": "Finished at",
  "结果": "Result",
  "缓存命中": "Cache hits",
  "缓存命中率": "Cache hit rate",
  "缓存效率": "Cache efficiency",
  "缓存未命中": "Cache misses",
  "编辑": "Edit",
  "编辑存储 · {{name}}": "Edit storage · {{name}}",
  "网格视图": "Grid view",
  "耗时": "Duration",
  "脱敏后的记录内容（只读）": "Redacted record contents (read-only)",
  "视频": "Video",
  "视频预览": "Video preview",
  "角色": "Role",
  "角色成员": "Role members",
  "解析工作簿": "Parsing workbook",
  "认证 ID：{{id}}": "Authentication ID: {{id}}",
  "认证用户 ID": "Authentication user ID",
  "认证用户（未关联）": "Authentication user (not linked)",
  "记录配置、角色及角色成员的变更。敏感配置只记录变更标记；没有身份上下文的操作显示为系统或未知来源。": "Records changes to configuration, roles, and role membership. Sensitive configuration only records a change marker. Actions without identity context appear as system or unknown source.",
  "该格式暂不支持预览，请下载查看": "Preview is not supported for this format. Download the file to view.",
  "详情": "Details",
  "请先停用存储": "Disable storage first",
  "请同时填写 {{name}}": "Also enter {{name}}",
  "请求": "Request",
  "请求 ID": "Request ID",
  "请求访问": "Access log",
  "请求路径": "Request path",
  "请输入名称": "Enter a name",
  "请输入完整 UUID": "Enter a complete UUID",
  "请输入标题": "Enter a title",
  "请输入正文": "Enter a message body",
  "请输入站内路径，例如 /profile": "Enter an internal path, e.g. /profile",
  "请选择发送渠道": "Select a delivery channel",
  "请选择收件人": "Select recipients",
  "请选择日期": "Select a date",
  "请选择用户查看登录会话": "Select a user to view login sessions",
  "请重试加载日志": "Retry loading logs",
  "调度已保存": "Schedule saved",
  "调度已移除": "Schedule removed",
  "调度间隔（秒）": "Schedule interval (seconds)",
  "账号启用中": "Account enabled",
  "账号头像 #{{id}}": "Account avatar #{{id}}",
  "账号已停用": "Account disabled",
  "资源": "Resource",
  "跳转路径": "Link path",
  "运行告警": "Operational alerts",
  "运行日志": "Application logs",
  "运行时版本": "Runtime version",
  "运行时间": "Uptime",
  "运行模式": "Mode",
  "还没有文件，点击上传或拖拽文件到这里": "No files yet. Click upload or drag files here.",
  "进程内存（重启即丢失）": "Process memory (lost on restart)",
  "连接客户端数": "Connected clients",
  "连接测试": "Test connection",
  "选择 {{name}}": "Select {{name}}",
  "选择本页全部文件": "Select all files on this page",
  "选择用户": "Select user",
  "选择目标存储后确认上传": "Select destination storage, then confirm upload",
  "通知": "Notifications",
  "通知已提交": "Notification submitted",
  "通知投递、保留清理、告警投递、变更历史清理和回收站清理由 Worker 固定调度，不能改间隔或删除。这里只能立即执行。": "Notification delivery, retention cleanup, alert delivery, change-history cleanup, and trash cleanup have fixed worker schedules. Their intervals cannot be changed or removed. You can only run them now.",
  "通知收件箱": "Notification inbox",
  "通知等待超过 5 分钟": "Notifications waiting more than 5 minutes",
  "逻辑 CPU 数": "Logical CPUs",
  "邮件": "Email",
  "配置": "Configuration",
  "配置保存后需重启 API 生效；切换默认存储只影响后续上传，不迁移历史文件。": "Restart the API after saving configuration. Changing default storage only affects future uploads and does not migrate existing files.",
  "配置待重启": "Configuration requires restart",
  "采集失败": "Collection failed",
  "采集成功": "Collection successful",
  "重命名 / 移动": "Rename / move",
  "重新加载": "Reload",
  "重置筛选": "Reset filters",
  "重试": "Retry",
  "重试加载文件夹": "Retry loading folders",
  "重试加载用户": "Retry loading users",
  "重试失败任务？": "Retry failed task?",
  "重试失败渠道": "Retry failed channels",
  "键数仅统计 DB {{database}}，其他指标为实例级数据。未提供的指标显示「—」；此页面不会读取或清理缓存内容。": "Key count covers only DB {{database}}; other metrics cover the entire instance. Unavailable metrics display “—”. This page does not read or clear cache contents.",
  "队列已恢复": "Queue resumed",
  "队列已暂停": "Queue paused",
  "队列未暂停": "Queue running",
  "队列状态不可用": "Queue status unavailable",
  "音频": "Audio",
  "音频预览": "Audio preview",
  "预览": "Preview",
  "预览失败或浏览器不支持该编码，请下载查看": "Preview failed or the browser does not support this encoding. Download the file to view.",
  "默认": "Default",
  "默认存储": "Default storage",
  "默认存储不能删除": "Default storage cannot be deleted",
  "（默认）": " (default)",
  "本地存储": "Local storage",
  "阿里云 OSS": "Alibaba Cloud OSS",
  "腾讯云 COS": "Tencent Cloud COS",
  "七牛云 Kodo": "Qiniu Kodo",
  "内存存储（仅测试）": "Memory storage (testing only)",
  "存储桶": "Bucket",
  "S3 空间名": "S3 bucket name",
  "包含 APPID，例如 files-1250000000": "Include the APPID, e.g. files-1250000000",
  "在七牛控制台的空间概览中查看 S3 空间名": "Find the S3 bucket name in the bucket overview in the Qiniu console",
  "通知投递": "Notification delivery",
  "通知投递保留清理": "Notification retention cleanup",
  "运行告警投递": "Operational alert delivery",
  "变更历史保留清理": "Change-history retention cleanup",
  "回收站过期清理": "Expired trash cleanup"
}
